import { render } from "./FilaFolhetos.vue?vue&type=template&id=09d0c9d0"
import script from "./FilaFolhetos.vue?vue&type=script&lang=js"
export * from "./FilaFolhetos.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/frontend-valora/frontend-valora/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__